export type ArrayProjectFn<T, R> = (item: T, key: number, collection: T[]) => R;

export type ArrayFilterFn<T, R extends T = T> =
    ((item: T, key: number, collection: T[]) => boolean) |
    ((item: T, key: number, collection: T[]) => item is R);

export type ArraySortFn<T> = (item1: T, item2: T) => number;

export type ArrayReduceFn<T, R> = (accumulated: R, current: T, index: number, collection: T[]) => R;

export type DictionaryFilterFn<T extends object, R extends T[keyof T] = any> =
    ((item: T[keyof T], key: string, collection: T) => boolean) |
    ((item: T[keyof T], key: string, collection: T) => item is R);

export type DictionaryProjectFn<T extends object, R> = (item: T[keyof T], key: string, collection: T) => R;

export type DictionarySortFn<T extends object> = (item1: T[keyof T], item2: T[keyof T]) => number;

export type DictionaryReduceFn<T, R> = (accumulated: R, current: T[keyof T], index: string, collection: T) => R;

export type MappedObject<O, R, K extends keyof O = keyof O> = {
    [P in K]: R;
}

export function getProjectFn<O extends Function>(projectFn: O | string): O {
	if (typeof projectFn === 'function') return projectFn
	return (obj => obj[projectFn]) as any
}

export function getFilterFn<O extends Function>(filterFn: O | string): O {
	if (typeof filterFn === 'function') return filterFn
	return (obj => obj[filterFn] === true) as any
}

export function dictionaryToArray<T extends object>(dictionary: T): Array<KeyValue<keyof T, T[keyof T]>> {
	const keys = Object.keys(dictionary)
	const result = new Array(keys.length)
	for (let ii = 0; ii < keys.length; ii++) {
		result[ii] = {key: keys[ii], value: dictionary[keys[ii]]}
	}
	return result
}